import { useState } from "react";
import { buildEmbedSnippet } from "@/embed";

/** Per-quiz "Copy Code" button: copies the self-configuring embed snippet to the
 * clipboard, revealing it read-only when the clipboard API is unavailable. */
export function EmbedButton({ slug }: { slug: string }) {
  const [copied, setCopied] = useState(false);
  const [fallback, setFallback] = useState<string | null>(null);
  if (!slug) return null;

  const code = buildEmbedSnippet({
    slug,
    scriptUrl: `${window.location.origin}/widget.js`,
    trustScriptUrl: true,
  });

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      setFallback(code);
    }
  };

  return (
    <span className="flex items-center gap-2">
      <button type="button" className="btn-outline" onClick={onCopy}>
        {copied ? "Copied!" : "Copy Code"}
      </button>
      {fallback && (
        <textarea
          readOnly
          aria-label="embed snippet"
          className="field h-16 w-72 font-mono text-xs"
          value={fallback}
        />
      )}
    </span>
  );
}
